require('dotenv').config();

export const port = process.env.PORT;
export const host = `localhost:${port}`;
export const url = 'https://visitsleepover.com' || process.env.WEBSITE_URL;
export const socketUrl = 'https://visitsleepover.com' || process.env.SOCKET_URL;
export const socketPort = process.env.SOCKET_PORT;
export const apiUrl = 'https://visitsleepover.com/api' ||process.env.API_URL;
export const environment = true;

export const analytics = {  // https://analytics.google.com/
  google: { trackingId: 'UA-221658460-2' },
};

export const databaseUrl = process.env.DATABASE_URL;
export const coinbase = process.env.COINBASE_URL;
export const coinbaseCurrencyUrl = process.env.COINBASE_CURRENCY_URL;

export const locales = ['en-US', 'es', 'it-IT', 'fr-FR', 'pt-PT', 'ar', 'he']; // default locale is the first one

export const placeDetailURL = "https://places.googleapis.com/v1/places/";
export const autoCompleteURL = "https://places.googleapis.com/v1/places:autocomplete";

export const fileuploadDir = './images/upload/'; // Listing Photos Upload Directory
export const logouploadDir = './images/logo/'; // Logo upload directory
export const ogImageuploadDir = './images/ogImage/'; // OG Image Upload directory
export const banneruploadDir = './images/banner/'; // Home page Banner upload directory
export const profilePhotouploadDir = './images/avatar/'; // User Profile Photos Upload Directory
export const documentuploadDir = './images/document/'; // Document Upload
export const locationuploadDir = './images/popularLocation/'; // Location upload directory
export const homebanneruploadDir = './images/home/'; // Static block image upload directory
export const amenitiesUploadDir = './images/amenities/'; // Amenities upload directory
export const faviconUploadDir = './images/favicon/'; // Favicon images update directory
export const whyHostUploadDir = './images/whyhost/'; // whyHostUploadDir
export const cronTimezone = process.env.CRON_TIMEZONE;
export const searchLimit = 24;
export const searchPagination = 300;
export const restrictStaticPageDisable = [4, 5, 6, 7];

export const payment = {
  paypal: {
    returnURL: `${url}${process.env.PAYPAL_RETURN_URL}`,
    cancelURL: `${url}${process.env.PAYPAL_CANCEL_URL}`,
    redirectURL: {
      success: `${url}${process.env.PAYPAL_SUCCESS_REDIRECT_URL}`,
      cancel: `${url}${process.env.PAYPAL_CANCEL_URL}`
    },
    versions: {
      versionOne: '/v1',
      versionTwo: '/v2'
    },
    token_url: '/oauth2/token',
    payment_url: '/checkout/orders',
    capture_url: '/capture',
    payout_url: '/payments/payouts',
    refund: '/refund',
    refund_capture: '/payments/captures/'
  },
  stripe: {
    failure_url: `${url}${process.env.STRIPE_FAILURE_URL}?account=`,
    success_url: `${url}${process.env.STRIPE_SUCCESS_URL}?account=`,
  }
};

export const auth = {
  jwt: { secret: process.env.JWT_SECRET },
  redirectURL: {
    login: '/dashboard',
    verification: '/user/verification',
    userbanned: '/userbanned',
    returnURLDeletedUser: '/userbanned'
  },
  google: {
    returnURL: `${url}/login/google/return`,
  }
};
